import { render, staticRenderFns } from "./OrdManageList.vue?vue&type=template&id=79a26be1&scoped=true"
import script from "./OrdManageList.vue?vue&type=script&lang=js"
export * from "./OrdManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a26be1",
  null
  
)

export default component.exports